/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminUpdateTransactionStatusDto { 
    status: AdminUpdateTransactionStatusDto.StatusEnum;
    reason?: string;
}
export namespace AdminUpdateTransactionStatusDto {
    export type StatusEnum = 'pending' | 'completed' | 'failed' | 'refunded';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        Completed: 'completed' as StatusEnum,
        Failed: 'failed' as StatusEnum,
        Refunded: 'refunded' as StatusEnum
    };
}


